import { useState, useEffect } from "react";
import axios from "axios";
import { api_v3_list_of_clans } from "../utils/constants";

export const useClansData = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [clans, setClans] = useState([]);

  useEffect(() => {
    const loadClans = async () => {
      setLoading(true);
      try {
        const response = await axios.get(api_v3_list_of_clans());
        if (response.status === 200) {
          const clansList = response.data.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
          setClans(clansList);
        } else {
          setError(true);
        }
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadClans();
  }, []);

  return {
    loading,
    error,
    clans,
  };
};
